$(document).ready(function() {
    $('.reviews_badge').on('click', function() {
        $('html, body').animate({
            scrollTop: $('#lp_reviews').offset().top
        }, 800);
    });
});
$(document).ready(function() {
    // === Infinite strip setup for .reviews_2 ===
    var $track = $('.reviews_2');
    var originalWidth = 0;
    var infiniteInitialized = false;

    function setupInfiniteScroll() {
        if (infiniteInitialized || !$track.length) return;

        // original items
        var $originals = $track.find('.review_item').not('.is-clone');
        if ($originals.length <= 1) return; // no point with <=1 item

        // total width of original sequence
        originalWidth = 0;
        $originals.each(function() {
            originalWidth += $(this).outerWidth(true);
        });

        // clone full set before and after
        var $before = $originals.clone().addClass('is-clone');
        var $after  = $originals.clone().addClass('is-clone');

        $track.prepend($before);
        $track.append($after);

        // start in the middle sequence so there’s content both sides
        var trackEl = $track.get(0);
        if (trackEl) {
            trackEl.scrollLeft = originalWidth;
        }

        infiniteInitialized = true;
    }

    function normalizeInfiniteScroll() {
        if (!infiniteInitialized || !originalWidth || !$track.length) return;

        var trackEl = $track.get(0);
        if (!trackEl) return;

        var s = trackEl.scrollLeft;

        // middle (original) range is [0..3*originalWidth)
        // but we want user to stay in [0..3*originalWidth) and especially around middle
        if (s < originalWidth * 0.25) {
            // went too far left into the before-clones → jump right one set
            trackEl.scrollLeft = s + originalWidth;
        } else if (s > originalWidth * 2.75) {
            // went too far right into the after-clones → jump left one set
            trackEl.scrollLeft = s - originalWidth;
        }
    }

    setupInfiniteScroll();

    // ===== Bullet Sync =====
    var $bullets = $('.mobile_bullets button');

    function updateBulletsForCenter() {
        if (!$track.length || !$bullets.length) return;

        var trackEl = $track.get(0);
        var viewportCenter = trackEl.scrollLeft + trackEl.clientWidth / 2;

        var closest = null;
        var closestDist = Infinity;

        // find slide visually closest to center (clone or real)
        $track.find('.review_item').each(function() {
            var center = this.offsetLeft + this.offsetWidth / 2;
            var dist = Math.abs(center - viewportCenter);
            if (dist < closestDist) {
                closestDist = dist;
                closest = this;
            }
        });

        if (!closest) return;

        var url = $(closest).attr('data-url');
        if (!url) return;

        // activate bullet matching this original url
        $bullets.removeClass('active');
        $bullets.filter('[data-url="' + url + '"]').addClass('active');
    }

    // normalize after scroll settles a bit (prevents visible jitter)
    var normalizeTimeout;
    $track.on('scroll', function() {
        if (!infiniteInitialized) return;
        clearTimeout(normalizeTimeout);
        normalizeTimeout = setTimeout(normalizeInfiniteScroll, 80);
    });

    // update on scroll settle for bullets as well
    var bulletTimeout;
    $track.on('scroll', function() {
        clearTimeout(bulletTimeout);
        bulletTimeout = setTimeout(updateBulletsForCenter, 60);
    });

    // update after arrows
    $('.video_reviews_arrows button').on('click', function () {
        setTimeout(updateBulletsForCenter, 300);
    });

    // update after tapping item (centers first)
    $('.reviews_2').on('click', '.review_item', function() {
        setTimeout(updateBulletsForCenter, 300);
    });

    // bullet click → go to that slide
    $bullets.on('click', function() {
        var url = $(this).attr('data-url');
        if (!url) return;

        // find matching REAL slide (not clone)
        var $real = $track.find('.review_item:not(.is-clone)[data-url="' + url + '"]').first();
        if (!$real.length) return;

        var trackEl = $track.get(0);
        var center = $real[0].offsetLeft + $real[0].offsetWidth / 2;
        var target = center - trackEl.clientWidth / 2;

        trackEl.scrollTo({ left: target, behavior: 'smooth' });
    });

    // finally, set initial active bullet once everything is ready
    updateBulletsForCenter();

    // update on scroll settle
    var bulletTimeout;
    $track.on('scroll', function() {
        clearTimeout(bulletTimeout);
        bulletTimeout = setTimeout(updateBulletsForCenter, 60);
    });

    // update after arrows
    $('.video_reviews_arrows button').on('click', function () {
        setTimeout(updateBulletsForCenter, 300);
    });

    // update after tapping item (centers first)
    $('.reviews_2').on('click', '.review_item', function() {
        setTimeout(updateBulletsForCenter, 300);
    });

    $bullets.on('click', function() {
        var url = $(this).attr('data-url');
        if (!url) return;

        // find matching REAL slide (not clone)
        var $real = $track.find('.review_item:not(.is-clone)[data-url="' + url + '"]').first();
        if (!$real.length) return;

        var trackEl = $track.get(0);
        var center = $real[0].offsetLeft + $real[0].offsetWidth / 2;
        var target = center - trackEl.clientWidth / 2;

        trackEl.scrollTo({ left: target, behavior: 'smooth' });
    });



    // === Your existing logic, kept the same except arrows wrap removed ===

    $('.tab1').click(function(){
      $(this).addClass('active_tab');
      $('.tab2').removeClass('active_tab');
      $('.reviews_1').hide();
      $('.reviews_2').show();
      $('.video_reviews_arrows').show();
    });

    $(".tab2").click(function(){
      $(this).addClass('active_tab');
      $('.tab1').removeClass('active_tab');
      $('.reviews_1').show();
      $('.reviews_2').hide();
      $('.video_reviews_arrows').hide();
    });

    $(".video_modal .close_modal").click(function(){
      $('.video_modal').hide();
      $('.video_container video').trigger('pause'); 
    });

    $('.reviews_2').on('click', '.review_item', function() {
        var $trackVisible = $('.reviews_2:visible').first();
        var track         = $trackVisible.get(0);
        var isMobile      = window.matchMedia('(max-width: 767px)').matches;
    
        if (isMobile && track) {
            var item           = this;
            var itemCenter     = item.offsetLeft + item.offsetWidth / 2;
            var viewportCenter = track.scrollLeft + track.clientWidth / 2;
            var diff           = itemCenter - viewportCenter;
        
            var tolerance = item.offsetWidth * 0.1;
            if (Math.abs(diff) > tolerance) {
                var targetScrollLeft = track.scrollLeft + diff;
                track.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
                return;
            }
        }
      
        $('.video_modal').show();
        var dataUrl = $(this).attr('data-url');
        $('.video_container').hide();
        $('.video_container').each(function() {
            if ($(this).attr('data-url') === dataUrl) {
                $(this).show();
                var videoHeight = $(this).find('video').height();
                $(this).css('height', videoHeight);
                $(this).find('video').get(0).play();
            }
        });
    });

    $('.video_reviews_arrows button').on('click', function () {
      var $trackVisible = $('.reviews_2:visible').first();
      if (!$trackVisible.length) return;
  
      var track    = $trackVisible.get(0);
      var isNext   = $(this).index() === 1;
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      var gap      = 12;
  
      var $firstItem = $trackVisible.find('.review_item').first();
      if (!$firstItem.length) return;
  
      var itemWidth    = $firstItem.outerWidth(true);
      var scrollAmount = isMobile ? (itemWidth + gap) : track.clientWidth;
  
      // no custom wrap logic here; infinite is handled by normalizeInfiniteScroll
      track.scrollBy({
        left: isNext ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    });

    $('.video_modal').click(function(event) {
      $('.video_container video').trigger('pause'); 
      if (event.target === this) {
        $(this).hide();
      }
    });
    
});
